/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Milestone_Banner_LinkInputs */



/**
* | output |
* | --- |
* | "See what's new" |
*
* @param {Marketing_Milestone_Banner_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const marketing_milestone_banner_link = /** @type {((inputs?: Marketing_Milestone_Banner_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Milestone_Banner_LinkInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuigkeiten ansehen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir les nouveautés")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("查看更新内容")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("查看最新消息")
	if (locale === "ko") return /** @type {LocalizedString} */ ("새로운 소식 보기")
	return /** @type {LocalizedString} */ ("See what's new")
});